export default __webpack_public_path__ + "static/media/edital-eleicao-conselho-curador-2025.d0391fb2.pdf";